export default class TagService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id) {
		return this.apiService.callGet('versionRedirects/' + id)
	}

	getEntities(params) {
		return this.apiService.callGet('versionRedirects', params)
	}

	createEntity(params){
		return this.apiService.callPost('versionRedirects', params);
	}

	updateEntity(id, params){
		return this.apiService.callPut('versionRedirects/'+id, params);
	}

	deleteEntity(id) {
		return this.apiService.callDelete('versionRedirects/' + id)
	}
}



// WEBPACK FOOTER //
// ./src/service/VersionRedirectService.js